<template>
    <div class="price__base-price mt-4">
        <span class="table-title">{{ $t('components.price.base.own-cost.price.basic-price') }}</span>
<!--        <core-lever-->
<!--            class="ml-4"-->
<!--            labelClass="ml-3"-->
<!--            :label="$t('components.price.base.own-cost.price.seasons')"-->
<!--            labelPosition="right"-->
<!--        ></core-lever>-->
<!--        <core-lever-->
<!--            class="ml-4"-->
<!--            labelClass="ml-3"-->
<!--            :label="$t('components.price.base.own-cost.price.general-cancellation-policy')"-->
<!--            labelPosition="right"-->
<!--        ></core-lever>-->
        <table class="input-table my-4">
            <tbody>
            <tr
                v-if="items.length"
                v-for="(item, index) in items"
                :key="item.id"
            >
                <td class="first-border-radius">
                    <core-date-range-calendar
                        :start.sync="item.dateFrom"
                        :end.sync="item.dateUntil"
                    ></core-date-range-calendar>
                </td>
                <td class="col-2">
                    <core-money-input
                        class="text-center"
                        :placeholder="$t('components.price.base.own-cost.price.purchase-price')"
                        :amount="calculatedPurchasePrice(item)"
                    ></core-money-input>
                </td>
                <td class="col-2">
                    <core-money-input
                        class="text-center"
                        :placeholder="$t('components.price.base.own-cost.price.selling-price')"
                        :amount.sync="item.salePrice"
                    ></core-money-input>
                </td>
                <td>
                    <core-days-modal-picker
                        :days.sync="item.arrivalDays"
                    ></core-days-modal-picker>
                </td>
                <td class="border-0">
                    <core-icon
                        @click.native="clone(item)"
                        class="pointer"
                        :iconName="$t('general.clone')"
                        iconColor="#bdbdbd"
                    >
                        <icons-clone></icons-clone>
                    </core-icon>
                </td>
                <td class="border-0">
                    <core-icon
                        @click.native="remove(index)"
                        class="pointer"
                        :iconName="$t('general.remove')"
                        iconColor="#bdbdbd"
                    >
                        <icons-delete></icons-delete>
                    </core-icon>
                </td>
            </tr>
            </tbody>
        </table>
        <img
            class="ml-3 add-row"
            src="@/assets/svg/plus008CDD.svg"
            @click="add({})"
            :title="$t('general.add')"
        >
    </div>
</template>

<script>
import { addItem } from '@/mixins/addItem'
import { cloneItem } from '@/mixins/cloneItem'
import { removeItem } from '@/mixins/removeItem'

export default {
  data () {
    return {
      items: this.prices
    }
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    prices: {
      default: () => ([]),
      type: Array,
      required: false
    }
  },
  methods: {
    calculatedPurchasePrice (item) {
      let koeff = 1
      if (this.service && this.service.service.commission) {
        koeff = 1 - (this.service.service.commission / 100)
      }
      let purchasePrice = item.salePrice ? item.salePrice * koeff : item.purchasePrice
      item.purchasePrice = purchasePrice
      return purchasePrice
    }
  },
  mixins: [addItem, cloneItem, removeItem],
  watch: {
    items (val) {
      this.$emit('update:prices', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/base/own-cost/Price.vue